import { useState } from "react";
import "../../View/account-settings/AccountSettings.css";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import Sidebar from "../Sidebar";
import VivahApi from "../../api";

function ChangePasswordSection() {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [show, setShow] = useState({ current: false, next: false, confirm: false });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  function toggle(field) { setShow(s => ({ ...s, [field]: !s[field] })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus(null);
    if (form.next !== form.confirm) {
      setStatus({ type: 'error', text: 'New passwords do not match.' });
      return;
    }
    if (form.next.length < 8) {
      setStatus({ type: 'error', text: 'New password must be at least 8 characters.' });
      return;
    }
    setLoading(true);
    try {
      await VivahApi.Auth.changePassword(form.current, form.next);
      setStatus({ type: 'success', text: 'Password changed successfully.' });
      setForm({ current: '', next: '', confirm: '' });
    } catch (err) {
      setStatus({ type: 'error', text: err?.response?.data?.error || err.message || 'Failed to change password.' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="as-card">
      <div className="as-card-header">
        <div className="as-card-icon as-icon-lock">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect x="5" y="11" width="14" height="10" rx="2" stroke="#e50d7e" strokeWidth="1.8"/>
            <path d="M8 11V7a4 4 0 1 1 8 0v4" stroke="#e50d7e" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
        </div>
        <div>
          <h3 className="as-card-title">Change Password</h3>
          <p className="as-card-subtitle">Update your admin account password</p>
        </div>
      </div>

      {status && (
        <div className={`as-alert as-alert-${status.type}`}>{status.text}</div>
      )}

      <form className="as-form" onSubmit={handleSubmit}>
        {[
          { key: 'current', label: 'Current Password', placeholder: 'Enter current password', auto: 'current-password' },
          { key: 'next',    label: 'New Password',     placeholder: 'Min. 8 characters',      auto: 'new-password' },
          { key: 'confirm', label: 'Confirm New Password', placeholder: 'Repeat new password', auto: 'new-password' },
        ].map(({ key, label, placeholder, auto }) => (
          <div className="as-field" key={key}>
            <label>{label}</label>
            <div className="as-input-wrap">
              <input
                type={show[key] ? 'text' : 'password'}
                value={form[key]}
                onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                placeholder={placeholder}
                required
                autoComplete={auto}
              />
              <button type="button" className="as-eye" onClick={() => toggle(key)}>
                {show[key] ? '🙈' : '👁️'}
              </button>
            </div>
          </div>
        ))}

        <button className="as-btn as-btn-primary" type="submit" disabled={loading}>
          {loading ? 'Updating…' : 'Update Password'}
        </button>
      </form>
    </div>
  );
}

export default function AdminSettings() {
  return (
    <div className="gla_page" id="gla_page">
      <a href="#gla_page" className="gla_top ti ti-angle-up gla_go"></a>
      <Header />
      <div className="gla_page_title gla_image_bck gla_wht_txt" data-color="#282828">
        <div className="container text-left">
          <div className="row">
            <div className="col-md-8"><h1 className="gla_h1_title">Settings</h1></div>
          </div>
        </div>
      </div>

      <section id="gla_content" className="gla_content">
        <section className="gla_section">
          <div className="container">
            <div className="dashboard">
              <div className="row">
                <Sidebar />
                <div className="col-md-10 col-xs-12 dashboard_container">
                  <div style={{ maxWidth: 520 }}>
                    <ChangePasswordSection />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <Footer />
    </div>
  );
}
